import { render, staticRenderFns } from "./FilterHotels.vue?vue&type=template&id=33f99acf"
import script from "./FilterHotels.vue?vue&type=script&lang=js"
export * from "./FilterHotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/vercel/path0/components/common/Input.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,Card: require('/vercel/path0/components/common/Card.vue').default,Stars: require('/vercel/path0/components/partials/Stars.vue').default,Label: require('/vercel/path0/components/common/Label.vue').default,Rating: require('/vercel/path0/components/partials/Rating.vue').default})
